import React from 'react';

const StatusBoleto = (props) => {
    var classe = "badge";
    var texto = "Em aberto";
    if (props.boleto.quitado) {
      classe = "badge badge-ok";
      texto = "Pago";
    } else if (props.boleto.vencido) {
      classe = "badge badge-alert";
      texto = "Vencido";
    }
    return (<span className={classe}>{texto}</span>);
  }
  
  export default StatusBoleto;